import React from "react";

import { useCard } from "@orbital/games-frontend-library";
import { BoardRow } from "./BoardStyled";
import { CARD_PROPS } from "./interface";
import { handleWinCard } from "../../functions/cardHandlers";
import Card from "../../card/Card";

export default function CardBoard({
  colors,
  hand,
  selected,
  winningCombination,
}: CARD_PROPS) {
  const { handleCardColor, handleCardSuit, handleCardSymbol } = useCard();
  return (
    <BoardRow>
      {hand.map((card: any, index: any) => (
        <Card
          customClass={
            selected && selected[index] === "1" ? `hold card` : "card"
          }
          customProp={
            winningCombination && handleWinCard(index, winningCombination)
          }
          key={index}
          size="25px"
          width="52px"
          height="77px"
          suitSize="23px"
          suitColor={card && handleCardColor(
            card,
            colors.secondaryText,
            colors.secondaryBackground,
          )}
        >
          <p>{card && handleCardSymbol(card)}</p>
          {card && handleCardSuit(card)}
          {selected && selected[index] === "1" && <h3>HOLD</h3>}
        </Card>
      ))}
    </BoardRow>
  );
}
